import { Injectable, inject } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { SettingsService, LanguageCodes } from '@app/_services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class CustomDatepickerIntl extends MatDatepickerIntl {
	settingsService = inject(SettingsService);

	constructor() {
		super();
		this.updateTranslations(this.settingsService.currentAppLanguage);

		// Update translations when language changes
		this.settingsService.activeLang$
			.pipe(takeUntilDestroyed())
			.subscribe((lang) => {
				this.updateTranslations(lang as LanguageCodes);
			});
	}

	private updateTranslations(lang: LanguageCodes): void {
		const translations = this.getTranslations(lang);

		this.calendarLabel = translations.calendarLabel;
		this.openCalendarLabel = translations.openCalendarLabel;
		this.closeCalendarLabel = translations.closeCalendarLabel;
		this.prevMonthLabel = translations.prevMonthLabel;
		this.nextMonthLabel = translations.nextMonthLabel;
		this.prevYearLabel = translations.prevYearLabel;
		this.nextYearLabel = translations.nextYearLabel;
		this.prevMultiYearLabel = translations.prevMultiYearLabel;
		this.nextMultiYearLabel = translations.nextMultiYearLabel;
		this.switchToMonthViewLabel = translations.switchToMonthViewLabel;
		this.switchToMultiYearViewLabel = translations.switchToMultiYearViewLabel;

		// Notify Angular Material that the labels have changed
		this.changes.next();
	}

	private getTranslations(lang: LanguageCodes) {
		const translations = {
			[LanguageCodes.ESTONIAN]: {
				calendarLabel: 'Kalender',
				openCalendarLabel: 'Ava kalender',
				closeCalendarLabel: 'Sulge kalender',
				prevMonthLabel: 'Eelmine kuu',
				nextMonthLabel: 'Järgmine kuu',
				prevYearLabel: 'Eelmine aasta',
				nextYearLabel: 'Järgmine aasta',
				prevMultiYearLabel: 'Eelmised 24 aastat',
				nextMultiYearLabel: 'Järgmised 24 aastat',
				switchToMonthViewLabel: 'Vali kuu',
				switchToMultiYearViewLabel: 'Vali aasta',
			},
			[LanguageCodes.ENGLISH]: {
				calendarLabel: 'Calendar',
				openCalendarLabel: 'Open calendar',
				closeCalendarLabel: 'Close calendar',
				prevMonthLabel: 'Previous month',
				nextMonthLabel: 'Next month',
				prevYearLabel: 'Previous year',
				nextYearLabel: 'Next year',
				prevMultiYearLabel: 'Previous 24 years',
				nextMultiYearLabel: 'Next 24 years',
				switchToMonthViewLabel: 'Choose month',
				switchToMultiYearViewLabel: 'Choose year',
			},
		};

		return translations[lang] || translations[LanguageCodes.ESTONIAN];
	}
}
